import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenSourceIssue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M27.1429 12.6667H25.6191V9.61905C25.6191 5.41333 22.2058 2 18 2C13.7943 2 10.381 5.41333 10.381 9.61905H13.4286C13.4286 7.08952 15.4705 5.04762 18 5.04762C20.5296 5.04762 22.5715 7.08952 22.5715 9.61905V12.6667H8.85719C7.181 12.6667 5.80957 14.0381 5.80957 15.7143V30.9524C5.80957 32.6286 7.181 34 8.85719 34H27.1429C28.8191 34 30.1905 32.6286 30.1905 30.9524V15.7143C30.1905 14.0381 28.8191 12.6667 27.1429 12.6667ZM27.1429 30.9524H8.85719V15.7143H27.1429V30.9524ZM18 26.381C19.6762 26.381 21.0477 25.0095 21.0477 23.3333C21.0477 21.6571 19.6762 20.2857 18 20.2857C16.3239 20.2857 14.9524 21.6571 14.9524 23.3333C14.9524 25.0095 16.3239 26.381 18 26.381Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgOpenSourceIssue);
export { ForwardRef as ReactComponent };
